module.exports = __webpack_public_path__ + "img/virgin-logo.45404276.svg";